import type { ComicCard, SourceId } from '@/sources/types';

export interface AggregateSourceSnapshot {
  sourceId: SourceId;
  items: ComicCard[];
  error?: unknown;
  loading: boolean;
}

const ROUTE_RESTORATION_CACHE_TTL_MS = 60 * 60 * 1000;
const CACHE_LIMIT = 24;

interface AggregateCacheEntry {
  savedAt: number;
  results: AggregateSourceSnapshot[];
}

const aggregateCache = new Map<string, AggregateCacheEntry>();

export function readAggregateSearchCache(key: string): AggregateSourceSnapshot[] | undefined {
  const entry = aggregateCache.get(key);
  if (!entry) return undefined;
  if (Date.now() - entry.savedAt > ROUTE_RESTORATION_CACHE_TTL_MS) {
    aggregateCache.delete(key);
    return undefined;
  }
  aggregateCache.delete(key);
  aggregateCache.set(key, entry);
  return entry.results;
}

export function writeAggregateSearchCache(key: string, results: AggregateSourceSnapshot[]) {
  if (results.length === 0) return;
  aggregateCache.set(key, { savedAt: Date.now(), results });
  while (aggregateCache.size > CACHE_LIMIT) {
    const oldest = aggregateCache.keys().next().value;
    if (oldest === undefined) break;
    aggregateCache.delete(oldest);
  }
}
